<template>
    <div class="p-6">
        <div class="mx-auto text-center">
            <div class="bg-[#01ABC426] bg-opacity-15 border border-[#01ABC4] border-opacity-50 rounded-lg p-12 mb-8">
                <div class="flex gap-20">
                    <div class="w-44 h-44 my-auto">
                        <img :src="sideBarLogo" alt="IqinABox" class="w-full h-full object-fit" />
                    </div>
                    <div class="flex-1 text-left">
                        <h4 class="text-xl font-semibold mb-2">
                            {{ $t('views.monitoring.unlock.title') }}
                        </h4>
                        <ul class="space-y-2 mt-4">
                            <li class="flex items-center">
                                <Icon :src="IconSource.Check" class="w-4 h-4 mr-2 text-blue-600"></Icon>
                                <span class="font-bold">{{ $t('views.monitoring.unlock.features[0].title') }}</span>
                                <span class="mx-1.5">-</span>
                                <span>{{ $t('views.monitoring.unlock.features[0].description') }}</span>
                            </li>
                            <li class="flex items-center">
                                <Icon :src="IconSource.Check" class="w-4 h-4 mr-2 text-blue-600"></Icon>
                                <span class="font-bold">{{ $t('views.monitoring.unlock.features[1].title') }}</span>
                                <span class="mx-1.5">-</span>
                                <span>{{ $t('views.monitoring.unlock.features[1].description') }}</span>
                            </li>
                            <li class="flex items-center">
                                <Icon :src="IconSource.Check" class="w-4 h-4 mr-2 text-blue-600"></Icon>
                                <span class="font-bold">{{ $t('views.monitoring.unlock.features[2].title') }}</span>
                                <span class="mx-1.5">-</span>
                                <span>{{ $t('views.monitoring.unlock.features[2].description') }}</span>
                            </li>
                            <li class="flex items-center">
                                <Icon :src="IconSource.Check" class="w-4 h-4 mr-2 text-blue-600"></Icon>
                                <span class="font-bold">{{ $t('views.monitoring.unlock.features[3].title') }}</span>
                                <span class="mx-1.5">-</span>
                                <span>{{ $t('views.monitoring.unlock.features[3].description') }}</span>
                            </li>
                            <li class="flex items-center">
                                <Icon :src="IconSource.Check" class="w-4 h-4 mr-2 text-blue-600"></Icon>
                                <span class="font-bold">{{ $t('views.monitoring.unlock.features[4].title') }}</span>
                                <span class="mx-1.5">-</span>
                                <span>{{ $t('views.monitoring.unlock.features[4].description') }}</span>
                            </li>
                        </ul>
                        <div class="mt-6">
                            <div class="monitoring-unlock-description" v-html="formattedDescription"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mt-6">
                <video v-if="videoUrl" class="w-full rounded-lg shadow-lg" controls preload="metadata">
                    <source :src="videoUrl" type="video/mp4" />
                    <p>{{ $t('views.monitoring.unlock.videoNotSupported', 'Your browser does not support the video tag.') }}</p>
                </video>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, computed, ref } from 'vue';
import { i18n } from '@/plugins/internationalization/i18n';
import { IconSource } from '@/types';

export default defineComponent({
    setup() {
        const sideBarLogo = `/solutions/${process.env.VUE_APP_SOLUTION_PATH}/assets/images/sidebar-logo.svg`;

        const formattedDescription = computed(() => {
            const text: string = i18n.global.t('views.monitoring.unlock.description');
            const linkText: string = i18n.global.t('views.monitoring.unlock.descriptionLinkReplacementText');
            const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+)/gi;
            let result = text.replace(urlRegex, (match) => {
                const href = match.startsWith('www.') ? `https://${match}` : match;
                return `<a href="${href}" target="_blank" rel="noopener noreferrer">${linkText}</a>`;
            });

            const phoneRegex = /(\d{2}\s\d{2}\s\d{2}\s\d{2})/g;
            result = result.replace(phoneRegex, (match) => {
                const phoneNumber = match.replace(/\s/g, '');
                return `<a href="tel:+45${phoneNumber}">${match}</a>`;
            });

            return result;
        });

        const videoUrl = ref<string | null>(null);
        setTimeout(() => {
            videoUrl.value = 'https://stpigs365sharedwesteu001.blob.core.windows.net/public/resources/videos/17062025_Store-Bouet-UK-FULD-UDGAVE.mp4';
        }, 1000);

        return {
            sideBarLogo,
            IconSource,
            formattedDescription,
            videoUrl,
        };
    },
});
</script>

<style>
.monitoring-unlock-description a {
    @apply text-blue-600 underline;
}
</style>
